module.exports = __webpack_public_path__ + "static/media/2.7d54b1eb.jpg";